import React from 'react';
import Main from '@/components/Main';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import StickyCountdown from '@/components/StickyCountdown';

import Banner from 'src/views/Banner';
import Confirmation from 'src/views/Confirmation';

export const SuccessConfirmation = ( { headline, children } ) => (
    <>
        <Header/>
        <Main>
            <Banner/>
            <Confirmation headline={ headline }>{ children }</Confirmation>
        </Main>
        <Footer/>
        <StickyCountdown/>
    </>
);


export default SuccessConfirmation;